/**
 * 新しい版を配った後、古い画面が動き続けることへの備え。
 *
 * ビルドごとにチャンクのファイル名が変わるため、開きっぱなしの画面が持っている
 * 名前は次の配信で消えている。そこへ動的 import が走ると、Worker は見つからない
 * パスに index.html を返す設定(SPA フォールバック)なので、ブラウザには
 * 「'text/html' is not a valid JavaScript MIME type」と映る。
 * HEIC を選んだときにだけ読み込むデコーダが、まさにこの形で失敗していた。
 */

/** 読み直しの間隔。これより短い間隔での再実行は無限ループとみなす */
const RELOAD_GUARD_MS = 30_000;

const RELOAD_KEY = "saranosuke:last-reload";

function reloadOnce(): void {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? "0");
  if (Number.isFinite(last) && Date.now() - last < RELOAD_GUARD_MS) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
}

export function keepAppFresh(): void {
  // チャンクを取れなかったら、配信済みの版が入れ替わったとみなして読み直す
  window.addEventListener("vite:preloadError", () => {
    reloadOnce();
  });

  if (!("serviceWorker" in navigator)) return;

  // 新しい Service Worker が主導権を取った時点で、画面上のコードは古い。
  // ただし初回インストール時にも同じイベントが起きるので、
  // 既に主導権を持つものが居た場合だけ読み直す。
  const hadController = navigator.serviceWorker.controller !== null;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (hadController) reloadOnce();
  });
}
